window.addEventListener('DOMContentLoaded', function () {
    const countryDivs = document.querySelectorAll('#country-divs [data-country]');
    const cityListItems = document.querySelectorAll('.city-list li');
    const cityPins = document.querySelectorAll('svg g');
    let isPinClick = false;

    function activateCity(selectedCity) {
        cityListItems.forEach(city => {
            city.classList.remove('is-active');
        });

        const selectedCityItem = document.querySelector(`.city-list li[data-city='${selectedCity}']`);

        if (selectedCityItem) {
            if (!isPinClick) {
                selectedCityItem.classList.add('is-active');
            }
        }

        cityPins.forEach(pin => pin.style.transform = 'scale(1)');
        const cityPin = document.querySelector(`g#${selectedCity}`);

        if (cityPin) {
            cityPin.style.transform = 'scale(1.4)';
        }
    }

    const style = document.createElement('style');
    style.innerHTML = `
        .active-pin {
            transform: scale(1.4);
            transition: transform 0.2s ease;
        }
    `;
    document.head.appendChild(style);

    function hideAllCityBlocks() {
        document.querySelectorAll('.city-block').forEach(cityBlock => {
            cityBlock.style.display = 'none';
        });
    }

    function showCitiesOfSelectedCountry(selectedCountry) {
        const citiesToShow = document.getElementById(`${selectedCountry}-cities`);
        if (citiesToShow) {
            citiesToShow.style.display = 'block';

        }
    }

    function handleCountrySelection(country) {
        const selectedCountry = country.getAttribute('data-country');

        const firstCountryDiv = document.querySelector('#country-divs > div:not(#second-container)');
        const selectedCountryDiv = document.querySelector(`#country-divs [data-country="${selectedCountry}"]`);

        if (firstCountryDiv !== selectedCountryDiv) {
            const parentContainer = selectedCountryDiv.parentElement;
            const tempDiv = document.createElement('div');

            firstCountryDiv.replaceWith(tempDiv);
            parentContainer.replaceChild(firstCountryDiv, selectedCountryDiv);
            tempDiv.replaceWith(selectedCountryDiv);
        }

        document.querySelectorAll('#countries li.is-active').forEach(activeCountry => {
            activeCountry.classList.remove('is-active');
        });
        country.classList.add('is-active');

        hideAllCityBlocks();
        showCitiesOfSelectedCountry(selectedCountry);
    }

    countryDivs.forEach(countryDiv => {
        countryDiv.addEventListener('click', function () {
            const selectedCountry = this.getAttribute('data-country');
            const correspondingCountryItem = document.querySelector(`#countries li[data-country="${selectedCountry}"]`);
            if (correspondingCountryItem) {
                handleCountrySelection(correspondingCountryItem);
            }
        });
    });

    cityListItems.forEach(cityItem => {
        cityItem.addEventListener('click', function () {
            const selectedCity = this.getAttribute('data-city');
            activateCity(selectedCity);
        });
    });

    function activateCityList(selectedCity) {
        cityListItems.forEach(city => {
            city.classList.remove('is-active');
        });

        const selectedCityItem = document.querySelector(`.city-list li[data-city='${selectedCity}']`);
        if (selectedCityItem) {
            selectedCityItem.classList.add('is-active');
        }

        cityPins.forEach(pin => {
            pin.style.transform = 'scale(1)';
        });

        const cityPin = document.querySelector(`g#${selectedCity}`);
        if (cityPin) {
            cityPin.style.transform = 'scale(1.4)';
        }
    }

    cityPins.forEach(pin => {
        pin.addEventListener('click', function () {
            const selectedCity = this.getAttribute('id');
            activateCityList(selectedCity);
        });
    });

    document.querySelectorAll('#countries li').forEach(country => {
        country.addEventListener('click', function () {
            handleCountrySelection(this);
        });
    });

    function initializePage() {
        const defaultCity = 'paris';
        activateCity(defaultCity);

        const countryToSelect = 'france';
        const countryItem = document.querySelector(`#countries li[data-country='${countryToSelect}']`);
        if (countryItem) {
            handleCountrySelection(countryItem);
        }
    }

    initializePage();
});
